class ResultsBatcher {
    constructor(api, onBatchUpdate) {
        this.api = api;
        this.onBatchUpdate = onBatchUpdate;
        this.results = [];
    }

    postResult(result) {
        this.results.push(result);

        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(this.onTimerExpired, 500);
    }

    onTimerExpired = () => {
        // copy the results so subsequent updates
        let results = [].concat(this.results);
        this.results = [];
        let locations = [];

        results.forEach((result, index) => {
            this.api.locationByKeyPromise(result.key).then((locationSnapshot) => {
                let location = locationSnapshot.val();
                let key = locationSnapshot.key;
                if (location) {
                    // console.log("found location");
                    location.key = key;
                    location.distance = result.distance;
                    locations.push(location);
                }
                if (index === results.length - 1) {
                    this.onBatchUpdate(locations);
                }
            });
        });
    }
}

export default ResultsBatcher;


// WEBPACK FOOTER //
// ./src/api/ResultsBatcher.js